export const pushPageWrap =
  'flex h-[calc(100dvh-5.5rem)] max-h-[calc(100dvh-5.5rem)] min-h-0 flex-col overflow-hidden rounded-none border-0 bg-white sm:min-h-[480px] sm:rounded-xl sm:border sm:border-gray-200 dark:bg-gray-900 dark:sm:border-gray-700';

export const pushShell = 'flex min-h-0 flex-1 overflow-hidden';

export const pushMobileTabs =
  'flex shrink-0 gap-0 overflow-x-auto border-b border-gray-200 bg-slate-50 dark:border-gray-700 dark:bg-gray-900 [-webkit-overflow-scrolling:touch]';

export const pushSubNavClass =
  'hidden w-14 shrink-0 flex-col items-center gap-1 overflow-y-auto border-r border-gray-200 bg-slate-50 py-3 dark:border-gray-700 dark:bg-gray-900/80 md:flex';

export const pushSubNavItem = (active: boolean) =>
  `flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${
    active
      ? 'bg-blue-600 text-white shadow-sm'
      : 'text-gray-500 hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
  }`;
